import { useNavigate } from 'react-router';

import { appPaths } from '~/routes/app-paths';

interface NavigateToThemeProps {
  themeId?: string;
  searchParams?: URLSearchParams;
}

export const useNavigateToThemeOverview = () => {
  const navigate = useNavigate();

  const navigateToThemeOverview = (themeId: string) => {
    navigate({
      pathname: `${appPaths.themeOverview}/${themeId}`,
    });
  };

  const navigateToTheme = ({ themeId, searchParams }: NavigateToThemeProps) => {
    const newSearchParams = new URLSearchParams(searchParams);

    navigate({
      pathname: `${appPaths.themeOverview}/${themeId}`,
      search: newSearchParams.toString(),
    });
  };

  return {
    navigateToChatMessage: navigateToThemeOverview,
    navigateToTheme,
  };
};
